import {
  Attribute,
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Injector,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NgControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { UUID } from '../../models/uuid';

/** CHECKBOX_VALUE_ACCESSOR */
export const CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true,
};
/** No hay operación */
const noop = () => {};

/** Renderiza un CheckBox */
@Component({
  selector: 'comun-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [CHECKBOX_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  /** Referencia al elemento CheckBox */
  @ViewChild('checkbox', { static: true }) checkbox: ElementRef;
  private disabled = false;
  /** Inicializa el componente CheckBox */
  id = UUID.New();
  constructor(
    /** Nombre */ @Attribute('name') public name: string,
    private injector: Injector,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}
  /** Host Binding */
  @HostBinding('class') class = 'checkbox custom-checkbox';
  /** Texto del etiqueta del CheckBox */
  @Input() textTag = '';
  /** Indica si es requerido mensaje */
  @Input() requiredMessage: boolean;
  private _value: boolean;
  /** Cuando es tocado el elemento */
  public onTouched: () => void = noop;
  /** Cuando cambia el elemento */
  public onChange: (_: any) => void = noop;
  @Output() change = new EventEmitter<boolean>();
  /** Obtiene el valor del CheckBox */
  get value(): boolean {
    return this._value;
  }

  /** Asigna valor al CheckBox */
  set value(v: boolean) {
    if (v !== this._value) {
      this._value = v;
      // esto es un apaño para la validación
      if (v === false) {
        v = null;
      }
      if (!this.disabled) {
        this.cdr.detectChanges();
        this.onChange(v);
      }
    }
  }

  /** Escribe el valor */
  writeValue(value: any) {
    this.value = value;
  }

  /** Registra cuando cambia el valor del CheckBox */
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  /** Registra cuando es tocado el CheckBox */
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean) {
    if (isDisabled) {
      this.deshabilitar();
    } else {
      this.habilitar();
    }
  }
  ngOnInit(): void {
    const control: NgControl = this.injector.get<NgControl>(NgControl);
    if (control && control.status === 'DISABLED') {
      this.deshabilitar();
    }
  }

  private habilitar() {
    this.disabled = false;
    this.renderer.removeAttribute(this.checkbox.nativeElement, 'disabled');
  }

  private deshabilitar() {
    this.renderer.setAttribute(
      this.checkbox.nativeElement,
      'disabled',
      'disabled'
    );
    this.disabled = true;
  }

  changed() {
    this.change.emit(this.value);
  }
}
